export function staticContentHasErrored(bool) {
  return {
    type: 'STATIC_CONTENT_HAS_ERRORED',
    hasErrored: bool
  };
}

export function staticContentIsLoading(bool) {
  return {
    type: 'STATIC_CONTENT_IS_LOADING',
    isLoading: bool
  };
}

export function staticContentFetchDataSuccess(staticContent) {
  return {
    type: 'STATIC_CONTENT_FETCH_DATA_SUCCESS',
    staticContent
  };
}

const staticContentFetchData = (url) => {
  return (dispatch) => {
    dispatch(staticContentIsLoading(true));
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(staticContentIsLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((staticContent) => dispatch(staticContentFetchDataSuccess(staticContent)))
      .catch(() => dispatch(staticContentHasErrored(true)));
  };
};

export default staticContentFetchData;



// WEBPACK FOOTER //
// ./src/redux/actions/static_content.js